import UserRoles from "./UserRoles";

export default {
  ...UserRoles,
  SUPERADMIN: "SUPERADMIN",
};
